import { data } from './data';

export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-[#121214]/80 backdrop-blur-md border-b border-gray-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <img 
              src="/icon-square-rounded.webp" 
              alt="Da Frens Icon" 
              className="w-8 h-8 rounded-lg"
            />
            <h1 className="text-2xl font-bold bg-gradient-to-r from-[#cd41ff] to-purple-400 bg-clip-text text-transparent">
              {data.serverName}
            </h1>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a 
              href="#home" 
              className="text-gray-300 hover:text-[#cd41ff] transition-colors"
            >
              Home
            </a>
            <a 
              href="#features" 
              className="text-gray-300 hover:text-[#cd41ff] transition-colors"
            >
              Features
            </a>
            <a 
              href="#rules" 
              className="text-gray-300 hover:text-[#cd41ff] transition-colors"
            >
              Rules
            </a>
            <a 
              href="#join" 
              className="text-gray-300 hover:text-[#cd41ff] transition-colors"
            >
              Join
            </a>
          </nav>
          
          <div className="flex items-center space-x-4">
            <a 
              href="https://discord.gg/9RJDwDebmx" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-[#cd41ff]/20 hover:bg-[#cd41ff]/30 text-[#cd41ff] border border-[#cd41ff]/50 px-4 py-1.5 rounded-full transition-all hover:shadow-[0_0_15px_rgba(205,65,255,0.3)]"
            >
              Join Discord
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
